import React, { useEffect, useState } from "react";
import axios from "axios";
import "./CookieConsent.css";
import { initializeAnalytics } from "../utils/analytics";
import { saveCookieConsent } from "../services/user-service";

const CONSENT_VERSION = "1.0";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem("cookieConsent");
    const savedVersion = localStorage.getItem("cookieConsentVersion");

    if (!savedConsent || savedVersion !== CONSENT_VERSION) {
      setShowBanner(true);
      // trigger enter transition on next frame
      requestAnimationFrame(() => setIsVisible(true));
    }
  }, []);

  const handleConsent = async (consentType) => {
    setIsVisible(false); // play exit transition first

    localStorage.setItem("cookieConsent", consentType);
    localStorage.setItem("cookieConsentVersion", CONSENT_VERSION);

    if (consentType === "ACCEPT_ALL") {
      initializeAnalytics();
    }

    const token = localStorage.getItem("token");
    if (token) {
      try {
        await saveCookieConsent(consentType, CONSENT_VERSION);
        console.log("Cookie consent saved in backend");
      } catch (error) {
        console.error("Failed to save cookie consent", error);
      }
    }

    // unmount after the exit animation finishes
    setTimeout(() => setShowBanner(false), 250);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div
      className={`cookie-consent-banner ${isVisible ? "is-visible" : ""}`}
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
    >
      <div className="cookie-consent-content">
        <div className="cookie-consent-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
            <circle
              cx="12"
              cy="12"
              r="9"
              stroke="currentColor"
              strokeWidth="1.6"
            />
            <circle cx="9" cy="9.5" r="1.1" fill="currentColor" />
            <circle cx="14.5" cy="8.5" r="0.9" fill="currentColor" />
            <circle cx="15" cy="13.5" r="1" fill="currentColor" />
            <circle cx="9.5" cy="14.5" r="0.8" fill="currentColor" />
          </svg>
        </div>

        <div className="cookie-consent-text">
          <h5>We value your privacy</h5>
          <p>
            We use essential technologies to keep I-Chest working securely. You
            can choose whether to allow optional technologies.
          </p>
        </div>

        <div className="cookie-consent-actions">
          <button
            type="button"
            className="btn-tertiary"
            onClick={() => handleConsent("DECLINE_OPTIONAL")}
          >
            Decline Optional
          </button>

          <button
            type="button"
            className="btn-secondary"
            onClick={() => handleConsent("ESSENTIAL_ONLY")}
          >
            Essential Only
          </button>

          <button
            type="button"
            className="btn-primary"
            onClick={() => handleConsent("ACCEPT_ALL")}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;